  function toggleDescription(element) {
    const fullDesc = element.closest('.video-content').querySelector('.full-description');
    if (fullDesc.style.display === 'block') {
      fullDesc.style.display = 'none';
      element.textContent = 'Read more';
    } else {
      fullDesc.style.display = 'block';
      element.textContent = 'Read less';
    }
  }

  // Initially hide all full descriptions
  document.querySelectorAll('.full-description').forEach(desc => {
    desc.style.display = 'none';
  });

  function playVideo(button) {
    const card = button.closest('.video-card');
    const iframe = card.querySelector('iframe');
    button.style.display = 'none';
    iframe.style.display = 'block';
    const src = iframe.src;
    iframe.src = '';
    iframe.src = src;
  }

  document.addEventListener('DOMContentLoaded', () => {
    const input       = document.getElementById('searchInput');
    const suggBox     = document.getElementById('suggestions');
    const cards       = Array.from(document.querySelectorAll('.video-card[data-title]'));

    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase();
      suggBox.innerHTML = '';
      if (!q) return;

      cards
        .filter(c => c.dataset.title.toLowerCase().includes(q))
        .slice(0,5)
        .forEach(c => {
          const div = document.createElement('div');
          div.textContent = c.dataset.title;
          div.style.padding = '8px 12px';
          div.style.cursor = 'pointer';
          div.onclick = () => {
            // remove previous highlights
            document.querySelectorAll('h3.highlight').forEach(h => h.classList.remove('highlight'));
            // scroll & highlight
            c.scrollIntoView({behavior:'smooth',block:'center'});
            const h3 = c.querySelector('h3');
            if (h3) h3.classList.add('highlight');
            // clear suggestions
            suggBox.innerHTML = '';
            input.value = c.dataset.title;
          };
          suggBox.appendChild(div);
        });
    });

    // hide on outside click
    document.addEventListener('click', e => {
      if (!suggBox.contains(e.target) && e.target !== input) {
        suggBox.innerHTML = '';
      }
    });
  });

  function filterVideos(){
    const searchInput = document.getElementById('searchInput').value.toLowerCase();
        const videos = document.querySelectorAll('.video-card');

        videos.forEach(videoItem => {
            const title = videoItem.querySelector('.video-content h3').textContent.toLowerCase();
            // const description = videoItem.querySelector('.full-description').textContent.toLowerCase();

            // if (title.includes(searchInput) || description.includes(searchInput)) {
            if (title.includes(searchInput)) {
                videoItem.style.display = 'block';
            } else {
                videoItem.style.display = 'none';
            }
        });
  }

  function toggleDescription(elem) {
    const fullDesc = elem.closest('.video-content').querySelector('.full-description');
    if (fullDesc.style.display === 'block') {
      fullDesc.style.display = 'none';
    } else {
      fullDesc.style.display = 'block';
    }
  }


// check window
document.addEventListener('DOMContentLoaded', function () {
    const userAgent = navigator.userAgent.toLowerCase();
    const body = document.body;

    if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
        // Add class for iPhone or iPad
        body.classList.add('iphone-device');
    } else if (userAgent.includes('android')) {
        // Add class for Android
        body.classList.add('android-device');
    } else if (userAgent.includes('chrome')) {
        // Add class for Chrome (but not on Android/iPhone since they're handled above)
        body.classList.add('chrome-browser');
    } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
        // Add class for Safari (excluding Chrome)
        body.classList.add('safari-browser');
    } else {
        // Fallback for other devices or browsers
        body.classList.add('other-device');
    }

    // check screen
  //   if (window.innerWidth <= 1024) {
  //   var device = document.querySelector(".iphone-device");
  //     if(device){
  //         document.querySelector(".dekstop-video-wrap").remove();
  //     } else {
  //       document.querySelector(".mobile-video-wrap").remove();
  //     }
  // } else {
  //   document.querySelector(".mobile-video-wrap").remove();
  // }
  if (window.innerWidth <= 1024) {
      const videoMenuLink = document.querySelector(".main-menu-links li.main-menu-list-item:nth-child(6) a");
  if (videoMenuLink) {
    videoMenuLink.addEventListener("click", function (e) {
      e.preventDefault(); // optional: prevent default if it's already a link
      window.location.href = '/pages/our-video-mob';
    });
  }

  }

});


// Handle More Function
function handleMobMore(button, event) {
    event.preventDefault(); // Prevent default anchor behavior

    const currentSection = button.closest('.mob-show-more1, .mob-show-more2, .mob-show-more3');
    const allSections = ['mob-show-more1', 'mob-show-more2', 'mob-show-more3', 'mob-show-more4'];

    const currentIndex = allSections.findIndex(cls => currentSection.classList.contains(cls));

    if (currentIndex !== -1 && currentIndex < allSections.length - 1) {
      currentSection.remove();

      const nextSection = document.querySelector(`.${allSections[currentIndex + 1]}`);
      if (nextSection) {
        nextSection.style.display = 'block';
      }
    }
  }
